export default {
    namespaced: true,
    state: {
        tableData: [
            // {
            //     name:'小饿',
            //     term:'20240831',
            //     fen:'999',
            //     expire:'否'
            // },
            // {
            //     name:'小饿',
            //     term:'20240825',
            //     fen:'999',
            //     expire:'是'
            // },
        ]
    },
    mutations: {
        changeTableData(state, payload) {
            state.tableData = payload
        },
        removeOne(state, index) {
            state.tableData.splice(index, 1)
        }
    }
}